import { useOptionalLocale } from "../../../intl";
import "./casaMapaMapControls.css";

const COPY = "realEstate.casaMapa.search.mapControls";
const PAN_PX = 140;

const BASEMAPS = [
  { id: "light", labelKey: "light" },
  { id: "streets", labelKey: "streets" },
  { id: "satellite", labelKey: "satellite" },
];

function label(t, key, fallback) {
  return t ? t(`${COPY}.${key}`) : fallback;
}

export default function CasaMapaMapControls({
  onZoomIn,
  onZoomOut,
  onPan,
  basemap = "light",
  onBasemapChange,
}) {
  const locale = useOptionalLocale();
  const t = locale?.t;

  return (
    <div className="cm-map-controls" role="group" aria-label={label(t, "label", "Map controls")}>
      <div className="cm-map-controls__basemap" role="group" aria-label={label(t, "basemap", "Base map")}>
        {BASEMAPS.map((option) => (
          <button
            key={option.id}
            type="button"
            className={`cm-map-controls__basemap-btn${basemap === option.id ? " is-active" : ""}`}
            aria-pressed={basemap === option.id}
            onClick={() => onBasemapChange?.(option.id)}
          >
            {label(t, option.labelKey, option.id)}
          </button>
        ))}
      </div>

      <div className="cm-map-controls__group cm-map-controls__group--pan" role="group" aria-label={label(t, "pan", "Pan")}>
        <button
          type="button"
          className="cm-map-controls__btn cm-map-controls__btn--north"
          onClick={() => onPan?.(0, -PAN_PX)}
          aria-label={label(t, "panNorth", "Pan north")}
        >
          ↑
        </button>
        <div className="cm-map-controls__pan-row">
          <button
            type="button"
            className="cm-map-controls__btn"
            onClick={() => onPan?.(-PAN_PX, 0)}
            aria-label={label(t, "panWest", "Pan west")}
          >
            ←
          </button>
          <button
            type="button"
            className="cm-map-controls__btn"
            onClick={() => onPan?.(PAN_PX, 0)}
            aria-label={label(t, "panEast", "Pan east")}
          >
            →
          </button>
        </div>
        <button
          type="button"
          className="cm-map-controls__btn cm-map-controls__btn--south"
          onClick={() => onPan?.(0, PAN_PX)}
          aria-label={label(t, "panSouth", "Pan south")}
        >
          ↓
        </button>
      </div>

      <div className="cm-map-controls__group" role="group" aria-label={label(t, "zoom", "Zoom")}>
        <button type="button" className="cm-map-controls__btn" onClick={onZoomIn} aria-label={label(t, "zoomIn", "Zoom in")}>
          +
        </button>
        <button type="button" className="cm-map-controls__btn" onClick={onZoomOut} aria-label={label(t, "zoomOut", "Zoom out")}>
          −
        </button>
      </div>
    </div>
  );
}
